// "use client"

// import { Heading } from "@/components/ui/Heading"
// import { useDictionary } from "@/core/hooks/use-dictionary"
// import MaterialSelector from "./MaterialSelector"
// import { MainShopProduct } from "@/core/models/shop-product-model"
// import { formatPrice } from "@/utils/formatPrice"
// import { AddToCartButton } from "./AddToCartButton"

// interface ProductColor {
//   product_id: string
//   color_code: string
//   color_code_2?: string
//   color_title: string
// }

// interface ProductInformationProps {
//   product: MainShopProduct
//   woodOptions?: ProductColor[]
//   fabricOptions?: ProductColor[]
//   onAddToCart?: () => void
// }
// export default function ProductInformation({ product, woodOptions = [], fabricOptions = [] }: ProductInformationProps) {
//   const { dictionary } = useDictionary()

//   const price = Number(product.price)
//   const finalPrice = Number(product.final_price)

//   const hasWood = woodOptions.length > 0
//   const hasFabric = fabricOptions.length > 0
//   return (
//     <div className="flex flex-col gap-5">
//       {/* Title & Color */}
//       <div className="flex flex-col gap-2">
//         <Heading level={1}>
//           {product.title}
//         </Heading>
//         <p className="text-sm  text-primary-600">{product.color_title}</p>
//       </div>

//       {/* Price */}
//       <div className="flex items-baseline gap-3 flex-wrap">
//         {(price === 0 || finalPrice === 0) ? (
//           <span className="text-sm tracking-[0.15em] uppercase text-primary-900 font-medium">
//             {dictionary.ui.form.contactus}
//           </span>
//         ) : product.discount_percent > 0 ? (
//           <>
//             <span className="text-xl text-primary-900 font-semibold">{formatPrice(finalPrice)} {dictionary.ui.product.currency}</span>
//             <span className="text-primary-600 line-through text-sm">{formatPrice(price)}</span>
//             <span className="text-sm px-2.5 py-1 bg-destructive text-primary-0 tracking-[0.15em] uppercase">
//               {product.discount_percent}%
//             </span>
//           </>
//         ) : (
//           <span className="text-xl text-primary-900 font-semibold">{formatPrice(price)} {dictionary.ui.product.currency}</span>
//         )}
//       </div>

//       {/* Short description */}
//       {product.description && (
//         <p className="text-sm text-primary-600 leading-relaxed">{product.description}</p>
//       )}

//       <div className="h-px bg-primary-200" />

//       {/* Wood Type Selection */}
//       {hasWood && (
//         <MaterialSelector
//           label={dictionary.ui.status.wood}
//           options={woodOptions}
//           selectedId={product.id}
//           productSlug={product.slug}
//         />
//       )}

//       {/* Fabric Selection (single list, two-fabric items show split circles) */}
//       {hasFabric && (
//         <MaterialSelector
//           label={dictionary.ui.status.fabric}
//           options={fabricOptions}
//           selectedId={product.id}
//           productSlug={product.slug}
//         />
//       )}

//       {(hasWood || hasFabric) && <div className="h-px bg-primary-200" />}

//       {/* Quantity + Add to Cart */}
//       <div className="flex flex-col gap-3">
//         <div className="flex items-center gap-4">
//           {/* Add to cart button */}

//           <AddToCartButton productInfo={product} productInventory={product.inventory} />
//         </div>

//         {product.inventory > 0 && product.inventory <= 5 && (
//           <p className="text-xs text-accent tracking-wide">Only {product.inventory} left in stock</p>
//         )}
//       </div>
//     </div>
//   )
// }





"use client"

import { Heading } from "@/components/ui/Heading"
import { useDictionary } from "@/core/hooks/use-dictionary"
import MaterialSelector from "./MaterialSelector"
import { MainShopProduct } from "@/core/models/shop-product-model"
import { formatPrice } from "@/utils/formatUtils"
import { AddToCartButton } from "./AddToCartButton"
import { getProductDisplayText } from "../../utils/productText"
import { Badge } from "@/components/ui/badge"
import { getFabricInclusiveFinalPriceRial, getFabricInclusivePriceRial, getFabricPriceLabel } from "../../utils/productPriceExcerpt"

interface ProductColor {
  product_id: string
  color_code: string
  color_code_2?: string
  color_title: string
}

interface ProductInformationProps {
  product: MainShopProduct
  woodOptions?: ProductColor[]
  fabricOptions?: ProductColor[]
  onAddToCart?: () => void
  settings?: { discount_display_active?: string | null; fabric_rate_number?: string | null; fabric_rate_words?: string | null; vat_percentage?: string | null }
}
export default function ProductInformation({ product, woodOptions = [], fabricOptions = [], settings }: ProductInformationProps) {
  const { dictionary } = useDictionary()

  const price = Number(product.price)
  const finalPrice = Number(product.final_price)
  // وقتی این تنظیم غیرفعاله، برچسب تخفیف و قیمت خط‌خورده نشون داده نمی‌شه؛
  // فقط قیمت نهایی (که خودش شامل تخفیفه) به‌عنوان تنها قیمت نمایش داده می‌شه.
  const showDiscount = settings?.discount_display_active !== 'deactive'
  // همون منطق ProductCard: اگه محصول متراژ پارچه داشته باشه، قیمتی که نشون داده
  // می‌شه قیمتِ با‌احتساب‌پارچه‌ست، نه قیمت خام محصول - وگرنه بین لیست و صفحه‌ی
  // محصول عدد فرق می‌کنه.
  const fabricInclusivePrice = getFabricInclusivePriceRial(product, settings)
  const displayFinalPrice = getFabricInclusiveFinalPriceRial(product, settings)
  const fabricPriceLabel = getFabricPriceLabel(product, settings)

  // وندا و تولیکا از همون تم مشترک استفاده می‌کنن، ولی وندا نمی‌خواد
  // انتخابگر جنس چوب/پارچه رو نشون بده (فقط تولیکا)
  const isVanda = process.env.NEXT_PUBLIC_SITE_NAME === 'vanda'
  const hasWood = !isVanda && woodOptions.length > 0
  const hasFabric = !isVanda && fabricOptions.length > 0
  return (
    <div className="flex flex-col gap-6 p-4">
      {/* Title & Color */}
      <div className="flex flex-col gap-2">
        <Heading level={1}>
          {product.title}
        </Heading>
        <p className="text-sm text-primary-600">{product.color_title}</p>
      </div>

      {/* Price */}
      <div className="flex items-baseline gap-3 flex-wrap">
        {(price === 0 || finalPrice === 0) ? (
          <span className="text-sm text-primary-900">
            {dictionary.ui.form.contactus}
          </span>
        ) : product.discount_percent > 0 && showDiscount ? (
          <>
            <span className="text-lg font-bold text-primary-700">{formatPrice(displayFinalPrice)} {dictionary.ui.product.currency}</span>
            <span className="text-sm text-primary-400 line-through decoration-primary-400/70">{formatPrice(fabricInclusivePrice)}</span>
            <Badge variant="destructive" className="top-2 right-2 ltr:left-2 text-xs font-semibold rounded-md px-2.5 py-1 shadow-sm">
              {product.discount_percent}%
            </Badge>
          </>
        ) : (
          <span className="text-base text-primary-900 font-semibold">
            {formatPrice(fabricInclusivePrice)} {dictionary.ui.product.currency}
          </span>
        )}
      </div>

      {fabricPriceLabel && (
        <p className="text-xs text-primary-500 -mt-4">{fabricPriceLabel}</p>
      )}

      {/* Short description */}
      {getProductDisplayText(product).summaryText && (
        <div
          className="text-sm text-primary-600 leading-relaxed prose prose-sm"
          dangerouslySetInnerHTML={{ __html: getProductDisplayText(product).summaryText! }}
        />
      )}


      {/* Wood Type Selection */}
      {hasWood && (
        <MaterialSelector
          label={dictionary.ui.status.wood}
          options={woodOptions}
          selectedId={product.id}
          productSlug={product.slug}
        />
      )}

      {/* Fabric Selection (single list, two-fabric items show split circles) */}
      {hasFabric && (
        <MaterialSelector
          label={dictionary.ui.status.fabric}
          options={fabricOptions}
          selectedId={product.id}
          productSlug={product.slug}
        />
      )}


      {/* Quantity + Add to Cart */}
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-4">
          {/* Add to cart button */}
          <AddToCartButton productInfo={product} productInventory={product.inventory} />
        </div>

        {product.inventory > 0 && product.inventory <= 5 && (
          <p className="text-xs text-primary-900 tracking-wide">فقط {product.inventory} left in stock</p>
        )}
      </div>
    </div>
  )
}